export class Department {
  id: number;
  code: string | null;
  name: string;
  created: Date | null;
  created_by: number | null;
  last_modified: Date | null;
  last_modified_by: number | null;
}
